import { render, staticRenderFns } from "./validate.vue?vue&type=template&id=96a27ada&scoped=true&"
import script from "./validate.vue?vue&type=script&lang=ts&"
export * from "./validate.vue?vue&type=script&lang=ts&"
import style0 from "./validate.vue?vue&type=style&index=0&id=96a27ada&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96a27ada",
  null
  
)

export default component.exports